import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, LoadingOverlay } from "@mantine/core";
import ResellerBillingsWrapper from "src/features/resellerBillingHistory/ResellerBillingsWrapper";
const ResellerBillingsContainer = ({ isLoading }) => {
    return (_jsxs(Box, { pos: "relative", display: "flex", flex: "1", children: [_jsx(LoadingOverlay, { visible: isLoading }), !isLoading && _jsx(ResellerBillingsWrapper, {})] }));
};
export default ResellerBillingsContainer;
